import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Course, CourseCompareState } from 'Zustand/courseCompare';

interface CourseCompareActions {
    addCourse: (course: Course) => void;
    removeCourse: (course: Course) => void;
    clearCourses: () => void;
}

const maxCourses = 3;

const useCourseCompareStore = create(
    //persist stores state across page reloads or restarts
    persist<CourseCompareState & CourseCompareActions>(
        set => ({
            courses: [],
            addCourse: (course: Course) =>
                set(state => ({
                    courses:
                        state.courses.length < maxCourses
                            ? state.courses.some(storeCourse => storeCourse.id === course.id)
                                ? state.courses
                                : [...state.courses, course]
                            : state.courses
                })),
            removeCourse: (course: Course) =>
                set(state => ({
                    courses: state.courses.filter(storeCourse => storeCourse.id !== course.id)
                })),
            clearCourses: () => set({ courses: [] })
        }),
        {
            name: 'course-compare-store' // storage key
        }
    )
);

export default useCourseCompareStore;
